<template>
  <card>
    <list v-if="$store.state.user.is_root" :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink"
      :cardLink="cardLink" :isUpdate="true" :isAdd="false" :itemLink="itemLink" :setLink="setLink" :openItem="true"
      :fields="fields" :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "transaction",
      fields: [

      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_transaction",
      itemLink: "transactions",
      setLink: "transactions",
      columns: [
        {
          key: "client",
          object: "full_name",
          title: "Ученик",
          disableLink: true
        },
        {
          key: "business",
          object: "title",
          title: "Школа",
          disableLink: true
        },
        {
          key: "group",
          object: "title",
          title: "Класс",
          disableLink: true
        },
        {
          key: "guardian",
          object: "full_name",
          title: "Родитель",
          disableLink: true
        },
        {
          key: "is_active",
          title: "Активен"
        },
        {
          key: "tariff_name",
          title: "Тариф"
        },
        {
          key: "payment_name",
          title: "Платежная система"
        },
        {
          key: "is_paid",
          title: "Оплачен"
        },
        {
          key: "payment_cost",
          title: "Стоимость"
        },
        {
          key: "from_at",
          dateFormat: true,
          title: "С"
        },
        {
          key: "till_at",
          dateFormat: true,
          title: "По"
        },
        {
          key: "paid_at",
          dateTimeFormat: true,
          title: "Время оплаты"
        },
        {
          key: "cancel_at",
          dateTimeFormat: true,
          title: "Время отмены"
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>

</style>
